import { Contact } from './contact';

export class PractitionerRecord extends Contact {}
